import { AlpineComponent } from '@alpinejs/csp';

const Header = (): AlpineComponent => ({
  width: '100%',
  hidden: false,
  scrolled: false,
  y: 0,
  cachedY: 0,
  direction: 'down',
  init() {
    this.handleScroll();
    this.updateHeaderWidth();
    window.addEventListener('scroll', () => this.handleScroll());
  },
  updateHeaderWidth() {
    const { width } = this.$refs.wrapper.getBoundingClientRect();
    this.width = `${width}px`;
  },
  handleScroll() {
    const shrinkThreshold = window.innerHeight / 2;

    this.direction = window.scrollY > this.y ? 'down' : 'up';
    this.y = window.scrollY;
    this.scrolled = this.y > 0;

    if (this.direction === 'down') {
      this.cachedY = window.scrollY;
    }

    const showOnScrollUp =
      this.direction === 'up' &&
      this.y > shrinkThreshold &&
      this.cachedY - this.y > 100;

    this.hidden = showOnScrollUp ? false : this.y > shrinkThreshold;
  },
  handleMouseEnter() {
    this.hidden = false;
  },
  getStyle() {
    return `--header-width: ${this.width};`;
  },
  getClassName() {
    return {
      'header__inner--scrolled': this.scrolled,
      'header__inner--hidden': this.hidden,
      'header__inner--open-search': this.$store.general.isSearchOpen
    };
  }
});

export default Header;
